
import { EmAdditionInfo } from '@/modules/aftersales/types/carInfo'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ViewAdditionItem extends Vue {
  @Prop() additionInfo!: null | EmAdditionInfo
}
